import i from "./index33.js";
import l from "./index46.js";
import "./index31.js";
class r extends i {
  /** Returns HTMLElement selection start */
  get _unsafeSelectionStart() {
    const o = this.rootElement, t = o.getSelection && o.getSelection(), e = t && t.anchorOffset, n = t && t.focusOffset;
    return n == null || e == null || e < n ? e : n;
  }
  /** Returns HTMLElement selection end */
  get _unsafeSelectionEnd() {
    const o = this.rootElement, t = o.getSelection && o.getSelection(), e = t && t.anchorOffset, n = t && t.focusOffset;
    return n == null || e == null || e > n ? e : n;
  }
  /** Sets HTMLElement selection */
  _unsafeSelect(o, t) {
    if (!this.rootElement.createRange)
      return;
    const e = this.rootElement.createRange();
    e.setStart(this.input.firstChild || this.input, o), e.setEnd(this.input.lastChild || this.input, t);
    const n = this.rootElement, s = n.getSelection && n.getSelection();
    s && (s.removeAllRanges(), s.addRange(e));
  }
  /** HTMLElement value */
  get value() {
    return this.input.textContent || "";
  }
  set value(o) {
    this.input.textContent = o;
  }
}
l.HTMLContenteditableMaskElement = r;
export {
  r as default
};
